import {useEffect, useState} from 'react';
import {useWidget} from '../useWidget';

export function ActiveTopBar(): JSX.Element | null {
  const {header} = useWidget();

  const [topBarContent, setTopBarContent] = useState<JSX.Element | null>(
    header.getTopBar(),
  );

  useEffect(() => {
    const sub = header.topBarObservable().subscribe(setTopBarContent);
    return () => sub.unsubscribe();
  }, [header]);

  if (topBarContent) {
    return topBarContent;
  }

  return null;
}
